module.exports = __webpack_public_path__ + "img/Erzsa.e92074bf.jpg";